<section class="flex justify-between mb-3">
    <h1 class="text-2xl font-bold text-gray-800">Copias de seguridad</h1>
</section>

<div class="bg-white p-6 rounded-xl shadow-sm border border-gray-100 max-w-xl">
    <h2 class="text-sm font-semibold uppercase tracking-wider text-indigo-500 mb-3">
        Copia de seguridad de la base de datos
    </h2>

    <p class="text-sm text-gray-500 mb-6">
        Genera ahora mismo una copia de seguridad completa de la base de datos y la sube a la carpeta
        de Google Drive configurada en el servidor. Si algo falla, se avisa por correo.
    </p>

    <button type="button" (click)="runBackup()" [disabled]="running"
        class="px-4 py-2 bg-indigo-600 text-white text-xs font-semibold uppercase tracking-wider rounded-lg hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        {{ running ? 'Generando copia...' : 'Hacer copia de seguridad' }}
    </button>

    @if (lastMessage) {
    <p class="text-xs text-gray-400 mt-4">{{ lastMessage }}</p>
    }

    @if (authorizationUrl) {
    <div class="mt-4 p-4 rounded-lg border border-amber-200 bg-amber-50">
        <p class="text-xs font-semibold text-amber-800 mb-2">Enlace de autorización de Google Drive</p>
        <input type="text" readonly [value]="authorizationUrl" (focus)="$any($event.target).select()"
            class="w-full text-xs font-mono px-2 py-1.5 border border-amber-200 rounded bg-white text-gray-700 mb-3" />
        <div class="flex gap-2">
            <button type="button" (click)="copyAuthorizationUrl()"
                class="px-3 py-1.5 bg-white border border-amber-300 text-amber-800 text-xs font-semibold rounded-lg hover:bg-amber-100 transition-colors">
                {{ copied ? 'Copiado' : 'Copiar enlace' }}
            </button>
            <a [href]="authorizationUrl" target="_blank" rel="noopener noreferrer"
                class="px-3 py-1.5 bg-amber-600 text-white text-xs font-semibold rounded-lg hover:bg-amber-700 transition-colors">
                Abrir enlace
            </a>
        </div>
    </div>
    }
</div>
